/* zetse — product page behaviour (main-product.liquid). */
(function () {
document.querySelectorAll('.pdp[data-pdp]').forEach(function (root) {

  function fmt(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }

  /* Keep the fixed bar just above the bottom tab bar, whatever its height. */
  function placeBar() {
    var nav = document.querySelector('.bnav');
    var h = nav && getComputedStyle(nav).display !== 'none' ? nav.getBoundingClientRect().height : 0;
    root.style.setProperty('--pdp-nav-h', h + 'px');
  }
  placeBar();
  window.addEventListener('resize', placeBar);
  window.addEventListener('load', placeBar);

  /* "View product details" — closed until the customer asks for it. */
  var toggle = root.querySelector('[data-pdp-toggle]');
  var details = root.querySelector('[data-pdp-details]');
  var toggleLabel = root.querySelector('[data-pdp-toggle-label]');
  if (toggle && details) {
    toggle.addEventListener('click', function () {
      var open = details.hidden;
      details.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (toggleLabel) toggleLabel.textContent = open ? 'Hide product details' : 'View product details';
      if (open) {
        details.classList.remove('is-opening'); void details.offsetWidth; details.classList.add('is-opening');
      }
    });
  }

  var dots = root.querySelectorAll('[data-dot]');
  var slides = root.querySelectorAll('[data-slide]');
  var track = root.querySelector('[data-track]');
  if (track && slides.length > 1) {
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(slides, entry.target);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  var radios = root.querySelectorAll('input[name="id"][type="radio"]');
  var priceEls = root.querySelectorAll('span[data-price], strong[data-price]');
  var compareEls = root.querySelectorAll('s[data-compare]');
  var compareWrap = root.querySelector('[data-compare-wrap]');
  var discountEls = root.querySelectorAll('[data-discount]');
  var packEls = root.querySelectorAll('[data-pack]');

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      var price = Number(radio.dataset.price);
      var compare = Number(radio.dataset.compare || 0);
      var hasDiscount = compare > price;

      priceEls.forEach(function (el) { el.textContent = fmt(price); });
      compareEls.forEach(function (el) {
        el.hidden = !hasDiscount;
        if (hasDiscount) el.textContent = fmt(compare);
      });
      if (compareWrap) compareWrap.hidden = !hasDiscount;
      discountEls.forEach(function (el) {
        el.hidden = !hasDiscount;
        if (hasDiscount) el.textContent = Math.round((compare - price) / compare * 100) + '% off';
      });
      var packTxt = radio.dataset.pcs || radio.dataset.vtitle;
      if (packTxt) packEls.forEach(function (el) { el.textContent = packTxt; });
      root.querySelectorAll('.product-detail__variant').forEach(function (label) {
        label.classList.toggle('is-selected', label.querySelector('input').checked);
      });
    });
  });

  /* ---------- GSTIN: saved to the cart so it rides onto the order ---------- */
  var gst = root.querySelector('[data-gst]');
  if (gst) {
    var GST_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
    var gOpen = gst.querySelector('[data-gst-open]');
    var gForm = gst.querySelector('[data-gst-form]');
    var gIn = gst.querySelector('[data-gst-in]');
    var gName = gst.querySelector('[data-gst-name]');
    var gErr = gst.querySelector('[data-gst-err]');
    var gTitle = gst.querySelector('[data-gst-title]');
    var gLine = gst.querySelector('[data-gst-line]');
    var gLineDefault = gLine ? gLine.textContent : '';
    var gSave = gst.querySelector('[data-gst-save]');
    var gCancel = gst.querySelector('[data-gst-cancel]');

    function readSaved() { try { return JSON.parse(localStorage.getItem('zetse_gstin') || 'null'); } catch (e) { return null; } }
    function showSaved(d) {
      if (d && d.gstin) {
        gTitle.textContent = 'GSTIN ' + d.gstin + (d.name ? ' · ' + d.name : '');
        gLine.textContent = gLineDefault + ' Tap to change.';
        gst.classList.add('is-saved');
      } else {
        gTitle.textContent = 'Add GSTIN';
        gLine.textContent = gLineDefault;
        gst.classList.remove('is-saved');
      }
    }
    showSaved(readSaved());

    gOpen.addEventListener('click', function () {
      if (!gForm.hidden) { gForm.hidden = true; return; }
      var d = readSaved() || {};
      gIn.value = d.gstin || '';
      gName.value = d.name || '';
      gErr.hidden = true;
      gForm.hidden = false;
      gIn.focus();
    });
    gCancel.addEventListener('click', function () { gForm.hidden = true; });
    gIn.addEventListener('input', function () { gIn.value = gIn.value.toUpperCase().replace(/\s/g, ''); gErr.hidden = true; });

    gSave.addEventListener('click', function () {
      var v = gIn.value.trim().toUpperCase();
      var n = gName.value.trim();
      if (v && !GST_RE.test(v)) { gErr.hidden = false; return; }
      gSave.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'GSTIN': v, 'GST business name': v ? n : '' } })
      }).then(function () {
        var d = v ? { gstin: v, name: n } : null;
        try { if (d) localStorage.setItem('zetse_gstin', JSON.stringify(d)); else localStorage.removeItem('zetse_gstin'); } catch (e) {}
        showSaved(d);
        gForm.hidden = true;
      }).catch(function () {
        gErr.textContent = 'Could not save right now — please try again.';
        gErr.hidden = false;
      }).then(function () { gSave.disabled = false; });
    });
  }

  /* ---------- Brands in this category: brands that sell this same kind of product ---------- */
  var bSec = root.querySelector('[data-brands-sec]');
  var bRail = root.querySelector('[data-brands-rail]');
  if (bSec && bRail) {
    var bType = root.getAttribute('data-brand-types') || '';
    var bQuery = root.getAttribute('data-brand-query') || '';
    var urls = [];
    if (bType) urls.push('/collections/types?q=' + encodeURIComponent(bType) + '&section_id=pdp-brands');
    if (bQuery) urls.push('/search?q=' + encodeURIComponent(bQuery) + '&type=product&options%5Bprefix%5D=last&section_id=pdp-brands');
    Promise.all(urls.map(function (u) {
      return fetch(u).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (pages) {
      var seen = {}, tiles = [];
      pages.forEach(function (html) {
        if (!html) return;
        var box = document.createElement('div');
        box.innerHTML = html;
        box.querySelectorAll('[data-brands] .pdp-brandtile').forEach(function (t) {
          var k = t.getAttribute('data-brand');
          if (!k || seen[k]) return;
          seen[k] = 1;
          tiles.push(t);
        });
      });
      if (tiles.length < 2) return;
      tiles.forEach(function (t) { bRail.appendChild(t); });
      bSec.hidden = false;
    });
  }

  /* ---------- Frequently bought together: complementary picks, else the page's own fallback, else related ---------- */
  var fbt = root.querySelector('[data-fbt]');
  var fbtGrid = root.querySelector('[data-fbt-grid]');
  if (fbt && fbtGrid) {
    var recUrl = root.getAttribute('data-recs-url') + '?product_id=' + root.getAttribute('data-product-id') + '&limit=3&section_id=pdp-recs&intent=';
    function loadRecs(intent) {
      return fetch(recUrl + intent).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return '';
        var box = document.createElement('div');
        box.innerHTML = html;
        var holder = box.querySelector('[data-recs]');
        return holder && holder.querySelector('.p-card') ? holder.innerHTML : '';
      }).catch(function () { return ''; });
    }
    var fbTpl = root.querySelector('[data-fbt-fallback]');
    var fallback = fbTpl && fbTpl.innerHTML.indexOf('p-card') > -1 ? fbTpl.innerHTML : '';
    loadRecs('complementary').then(function (h) { return h || fallback || loadRecs('related'); }).then(function (h) {
      if (!h) return;
      fbtGrid.innerHTML = h;
      fbt.hidden = false;
    });
  }

  /* ---------- Image lightbox: click/tap to open, pinch (or wheel/drag) to zoom ---------- */
  var lightbox = root.querySelector('[data-lightbox]');
  var stage = root.querySelector('[data-lightbox-stage]');
  var lbImg = root.querySelector('[data-lightbox-img]');
  var lbClose = root.querySelector('[data-lightbox-close]');
  var lbPrev = root.querySelector('[data-lightbox-prev]');
  var lbNext = root.querySelector('[data-lightbox-next]');
  var lbHint = root.querySelector('[data-lightbox-hint]');
  var slideImgs = Array.prototype.map.call(slides, function (s) { return s.querySelector('img'); }).filter(Boolean);

  if (lightbox && stage && lbImg && slideImgs.length) {
    var lbIndex = 0;
    var scale = 1, panX = 0, panY = 0;
    var pinchStartDist = 0, pinchStartScale = 1;
    var dragStart = null, panStart = null;
    var lastTap = 0;
    var hintTimer = null;

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
    function applyTransform() {
      lbImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    }
    function resetZoom() { scale = 1; panX = 0; panY = 0; applyTransform(); }

    function show(index) {
      lbIndex = (index + slideImgs.length) % slideImgs.length;
      var full = slideImgs[lbIndex].getAttribute('data-full') || slideImgs[lbIndex].src;
      lbImg.src = full;
      lbImg.alt = slideImgs[lbIndex].alt || '';
      resetZoom();
    }

    function openLightbox(index) {
      show(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lbHint) {
        lbHint.style.opacity = '1';
        clearTimeout(hintTimer);
        hintTimer = setTimeout(function () { lbHint.style.opacity = '0'; }, 2200);
      }
    }
    function closeLightbox() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      resetZoom();
    }

    slideImgs.forEach(function (img, i) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () { openLightbox(i); });
    });
    root.querySelectorAll('[data-zoom-hint]').forEach(function (btn, i) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(i); });
    });

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    if (lbPrev) lbPrev.addEventListener('click', function () { show(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { show(lbIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') show(lbIndex + 1);
      if (e.key === 'ArrowLeft') show(lbIndex - 1);
    });

    function dist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinchStartDist = dist(e.touches);
        pinchStartScale = scale;
        dragStart = null;
      } else if (e.touches.length === 1) {
        if (scale > 1) {
          dragStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
          panStart = { x: panX, y: panY };
        } else {
          var now = Date.now();
          if (now - lastTap < 300) {
            scale = 2.5;
            applyTransform();
          }
          lastTap = now;
        }
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchStartDist) {
        e.preventDefault();
        var d = dist(e.touches);
        scale = clamp(pinchStartScale * (d / pinchStartDist), 1, 4);
        applyTransform();
      } else if (e.touches.length === 1 && dragStart && scale > 1) {
        e.preventDefault();
        panX = panStart.x + (e.touches[0].clientX - dragStart.x);
        panY = panStart.y + (e.touches[0].clientY - dragStart.y);
        applyTransform();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinchStartDist = 0;
      if (e.touches.length === 0) dragStart = null;
      if (scale < 1.02) resetZoom();
    });

    /* Desktop convenience: wheel to zoom, double-click to toggle, drag to pan when zoomed. */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.15 : 0.15;
      scale = clamp(scale + delta, 1, 4);
      if (scale <= 1) { panX = 0; panY = 0; }
      applyTransform();
    }, { passive: false });

    stage.addEventListener('dblclick', function () {
      if (scale > 1) { resetZoom(); } else { scale = 2.5; applyTransform(); }
    });

    var mouseDragging = false, mouseStart = null, mousePanStart = null;
    stage.addEventListener('mousedown', function (e) {
      if (scale <= 1) return;
      mouseDragging = true;
      mouseStart = { x: e.clientX, y: e.clientY };
      mousePanStart = { x: panX, y: panY };
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseDragging) return;
      panX = mousePanStart.x + (e.clientX - mouseStart.x);
      panY = mousePanStart.y + (e.clientY - mouseStart.y);
      applyTransform();
    });
    window.addEventListener('mouseup', function () { mouseDragging = false; });
  }
});
})();